import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';

export const StyledListItemText = styled(ListItemText, {
  shouldForwardProp: prop => prop !== 'marginLeft' && prop !== 'marginRight' && prop !== 'isSelected',
})<{
  isSelected?: boolean;
  marginLeft?: number;
  marginRight?: number;
}>`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0px;

  margin-right: ${({ marginRight }) => marginRight && marginRight}px;
  margin-left: ${({ marginLeft }) => marginLeft && marginLeft}px;
  color: ${({ theme, isSelected }) => (isSelected ? theme.palette.text.disabled : theme.palette.text.primary)};
`;
